import { isArray } from 'lodash';
import mergeProducts from '../../utils/mergeProducts';
import { IS_TEST_ENV } from '../../../../../constants/environment';

const initialState = {
  products: {
    buyProducts: [],
    productsFromGA: [],
    buyProductsGroups: [],
  },
};

const reducers = {
  resetProductsFromGA(state) {
    state.products.productsFromGA = [];
  },
};

const extraReducers = {
  'requests/get-favorites-products/fulfilled'(state, { payload }) {
    if (!isArray(payload?.groups)) {
      state.products.buyProductsGroups = [];
      state.products.buyProducts = [];
      return;
    }

    state.products.buyProductsGroups = payload.groups?.filter(Boolean);
    state.products.buyProducts = payload.products;
  },

  'requests/product-to-favorites/fulfilled'(state, { payload }) {
    if (!payload || !payload.product) {
      return;
    }

    const product = payload.product;
    const replaceProduct = (items, mapper) =>
      items?.map?.((prod) => (prod?.id === product?.id ? mapper(prod) : prod)) ?? items;

    state.products.buyProducts = replaceProduct(state.products.buyProducts, () => product);
    state.products.productsFromGA = replaceProduct(state.products.productsFromGA, (gaProduct) =>
      mergeProducts(product, gaProduct),
    );
  },

  'requests/get-web-catalog-products-by-sku/pending'(state) {
    // Не заполняем productsFromGA в pending, чтобы товары показывались только после загрузки
  },
  'requests/get-web-catalog-products-by-sku/fulfilled'(state, { payload, meta: { arg: itemSkus } }) {
    const buyProducts = state.products?.buyProducts ?? [];
    const { products = [] } = payload ?? {};

    if (!itemSkus || !isArray(itemSkus) || itemSkus.length === 0) {
      state.products.productsFromGA = [];
      return;
    }

    state.products.productsFromGA = itemSkus
      .map((sku) => {
        const defaultProduct = buyProducts.find(({ sku: itemSku }) => itemSku === sku);
        if (!defaultProduct) return null;

        const productFromGA = products.find(({ itemId }) => itemId === sku);
        if (productFromGA) return mergeProducts(defaultProduct, productFromGA);
        if (IS_TEST_ENV) return defaultProduct;
        return null;
      })
      .filter(Boolean); // Убираем null/undefined значения
  },
  'requests/get-web-catalog-products-by-sku-beauty-routine/fulfilled'(state, { payload, meta: { arg: itemSkus } }) {
    const buyProducts = state.products?.buyProducts ?? [];
    const { products = [] } = payload ?? {};

    if (!itemSkus || !isArray(itemSkus) || itemSkus.length === 0) {
      state.products.productsFromGA = [];
      return;
    }

    state.products.productsFromGA = itemSkus
      .map((sku) => {
        const defaultProduct = buyProducts.find(
          ({ sku: itemSku, beauty_routine_id }) => itemSku === sku && typeof beauty_routine_id === 'number',
        );
        if (!defaultProduct) return null;

        const productFromGA = products.find(({ itemId }) => itemId === sku);
        if (productFromGA) return mergeProducts(defaultProduct, productFromGA);
        if (IS_TEST_ENV) return defaultProduct;
        return null;
      })
      .filter(Boolean); // Убираем null/undefined значения
  },
  'requests/get-web-catalog-products-by-sku/rejected'(state, { meta: { arg: itemsSkus } }) {
    const buyProducts = state.products?.buyProducts ?? [];

    if (!itemsSkus || !isArray(itemsSkus) || itemsSkus.length === 0) {
      state.products.productsFromGA = [];
      return;
    }

    // Заполняем productsFromGA базовыми данными из buyProducts, фильтруя undefined
    state.products.productsFromGA = itemsSkus
      .map((sku) => buyProducts.find(({ sku: productSku }) => productSku === sku))
      .filter(Boolean);
  },
};

export const productsSegment = {
  initialState,
  reducers,
  extraReducers,
};
